import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'App/Store';

const getState = (state: RootState) => state.gates;

export const getGatesToken = createSelector(
  getState,
  (state) => state?.contextToken,
);

export const getGateMFAData = createSelector(
  getState,
  (state) => state?.mfa,
);

export const getIsVerifying = createSelector(
  getState,
  (state) => state?.isVerifying,
);

export const getSelectedDealerId = createSelector(
  getState,
  (state) => state?.selectedDealerId,
);

export const getGateConfig = createSelector(
  getState,
  (state) => state?.gateConfig,
);

export const getGateAuthToken = createSelector(
  getState,
  (state) => state?.token,
);